import { render, staticRenderFns } from "./AddMedicalCertificate.vue?vue&type=template&id=51dc0227"
import script from "./AddMedicalCertificate.vue?vue&type=script&lang=ts"
export * from "./AddMedicalCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports